<template>
  <main class="flex flex-col items-center gap-5 m-auto py-12 px-4">
    <img src="/logo.png" class="w-36 rounded-full bg-stone-900" alt="ClockTracker" />
    <h1 class="text-3xl font-sorts">Sign in</h1>
    <form class="flex flex-col gap-4 w-full max-w-sm" @submit.prevent="login">
      <label>Email<input v-model="email" type="email" autocomplete="username" required class="block w-full rounded p-2 text-black" /></label>
      <label>Password<input v-model="password" type="password" autocomplete="current-password" required class="block w-full rounded p-2 text-black" /></label>
      <Alert v-if="error" color="negative">{{ error }}</Alert>
      <Button type="submit" color="primary" :disabled="busy">{{ busy ? 'Signing in…' : 'Sign in' }}</Button>
    </form>
    <nuxt-link to="/reset-password" class="underline">Forgot your password?</nuxt-link>
  </main>
</template>

<script setup lang="ts">
const { data: status } = await useFetch("/api/auth/status");
if (status.value?.needsSetup) await navigateTo("/setup");
else if (useUser().value) await navigateTo("/");
const email = ref("");
const password = ref("");
const error = ref("");
const busy = ref(false);
async function login() {
  busy.value = true;
  error.value = "";
  try {
    await $fetch("/api/auth/login", { method: "POST", body: { email: email.value, password: password.value } });
    window.location.assign("/");
  } catch (e: any) {
    error.value = e.data?.statusMessage || "Unable to sign in. Try again.";
  } finally { busy.value = false; }
}
</script>
